import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, of } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';
import { companiesMockData } from '../../../../mock'

@Injectable({
  providedIn: 'root'
})
export class CredentialService {
  companiesMockData = companiesMockData;
  constructor(private http: HttpClient) { }


  saveComanies(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.COMPANIES + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.COMPANIES, payload)
      .pipe(catchError(errorHandl));

  }
  get(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.API_URL + urls.SERVICE_AREAS, { params })
      .pipe(
        catchError(errorHandl)
      );
  }
  // getPicker(queryParams?: any) {
  //   const params = new HttpParams({ fromObject: queryParams });
  //   return this.http.get<any>(urls.API_URL + urls.SERVICE_AREAS + urls.PICKER, { params })
  //     .pipe(
  //       catchError(errorHandl)
  //     );
  // }

  getPicker(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANIES + urls.PICKER, { params })
      .pipe(catchError(errorHandl));
  }


  getCompanies(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANIES, { params })
      .pipe(catchError(errorHandl));
  }

  getCompanyById(id: any) {
    return this.http.get(urls.API_URL + urls.COMPANIES + `/${id}`)
      .pipe(catchError(errorHandl));
  }


  getDashboardDetails(id: any) {
    return this.http.get(urls.API_URL + urls.COMPANIES + `/${id}/` + urls.DASHBOARD)
      .pipe(catchError(errorHandl));
  }

  getCompanyVerification(id: any) {
    // Temp Mock api
    return of(this.companiesMockData.find((company) => company.id == id));

    // Real api

    // return this.http.get(urls.API_URL + urls.CREDENTIAL_COMPANIES + `/${id}`)
    //   .pipe(catchError(errorHandl));
  }

  requestReviewCompany(id: any, payload: any) {
    return this.http.post(urls.API_URL + urls.COMPANIES + `/${id}/review-request`, payload)
  }

  updateCompnayInformation(id: any, payload: any) {
    return this.http.put(urls.API_URL + urls.CREDENTIAL_COMPANIES + `/${id}`, payload)
      .pipe(catchError(errorHandl));
  }

  // DRIVERS
  saveDrivers(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.All_DRIVERS + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.All_DRIVERS, payload)
      .pipe(catchError(errorHandl));

  }

  requestReviewDriver(id: any, payload: any) {
    return this.http.post(urls.API_URL + urls.DRIVERS + `/${id}/review-request`, payload)
  }


  getCompanyDrivers(id: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANY_DRIVERS + `/${id}`, { params })
      .pipe(catchError(errorHandl));
  }

  getPickerDrivers(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.DRIVERS + urls.PICKER, { params })
      .pipe(catchError(errorHandl));
  }

  getDriverById(id: any) {
    return this.http.get(urls.API_URL + urls.All_DRIVERS + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getDriverVerification(id: any) {
    return this.http.get(urls.API_URL + urls.COMPANY_DRIVERS + `${id}`)
      .pipe(catchError(errorHandl));
  }

  updateDriverVerification(id: any, payload: any) {
    return this.http.put(urls.API_URL + urls.COMPANY_DRIVERS + `${id}`, payload)
      .pipe(catchError(errorHandl));
  }

  // Vehicles

  // DRIVERS
  saveVehicle(id: any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.VEHICLES + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.VEHICLES, payload)
      .pipe(catchError(errorHandl));

  }

  // getCompanyDrivers(id: any, queryParams:any) {
  //   const params = new HttpParams({fromObject: queryParams});
  //   return this.http.get(urls.API_URL + urls.COMPANY_DRIVERS + `/${id}`, {params})
  //     .pipe(catchError(errorHandl));
  // }

  getVehicles(id: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANY_VEHICLES + `/${id}`,{params})
      .pipe(catchError(errorHandl));
  }

   getPickerVehicles(queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.VEHICLES + urls.PICKER, { params })
      .pipe(catchError(errorHandl));
  }

  getVehicleById(id: any) {
    return this.http.get(urls.API_URL + urls.VEHICLES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getVehicleVerification(id: any) {
    return this.http.get(urls.API_URL + urls.CREDENTIAL_VEHICLES + `${id}`)
      .pipe(catchError(errorHandl));
  }

  updateVehicleVerification(id: any, payload: any) {
    return this.http.put(urls.API_URL + urls.CREDENTIAL_VEHICLES + `${id}`, payload)
      .pipe(catchError(errorHandl));
  }

  requestReviewVehicle(id: any, payload: any) {
    return this.http.post(urls.API_URL + urls.VEHICLES + `/${id}/review-request`, payload)
  }

  // Fare
  saveFare(id:any, payload: any) {
    if (id) {
      return this.http.patch(urls.API_URL + urls.FARES + `/${id}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.FARES, payload)
      .pipe(catchError(errorHandl));

  }

  getFareById(id: any) {
    return this.http.get(urls.API_URL + urls.FARES + `/${id}`)
      .pipe(catchError(errorHandl));
  }

  getCompanyFares(id: any, queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.COMPANY_FARRES + `/${id}`, { params })
      .pipe(catchError(errorHandl));
  }


  updateCompanyVerification(id: any, payload: any) {
    return this.http.patch(urls.API_URL + urls.COMPANIES + `/${id}/manage`, payload)
      .pipe(catchError(errorHandl));
  }

   save( configId: any, payload: any) {
    if (configId) {
      return this.http.patch(urls.API_URL + urls.COMPANY_CONFIGURATION + `/${configId}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.COMPANY_CONFIGURATION, {...payload,})
      .pipe(catchError(errorHandl));

  }

   getConfigByCompanyWise(companyId: any) {
    return this.http.get(
      `${urls.API_URL}${urls.CONFIG_COMPANY_WISE}/${companyId}`
    ).pipe(catchError(errorHandl));
  }

  syncData(id: any, type:any) {
    return this.http.get(urls.API_URL + type + `/${id}/sync`)
  }

    searchData(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http
      .get(urls.API_URL + urls.SEARCH_MEMBERS, { params })
      .pipe(catchError(errorHandl));
  }

  getDrivers(queryParams?: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.DRIVERS, { params })
      .pipe(catchError(errorHandl));
  }

  getAllVehicles(queryParams: any) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.VEHICLES, { params })
      .pipe(catchError(errorHandl));
  }

}
